import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import GoogleMapReact from "google-map-react";
import { consts } from '../../../../common/consts';
import { IVehicleLocation } from '../../../../common/types';
import api from '../../../../store/api';
import TeamVehicleMarker from './TeamVehicleMarker';
import { getMaxDistance, preapreETA } from '../calloutRequestedHelpers';
import { APIResponseModel, APIResponseModelTomTom } from '../types/MapAPI'


interface TeamOnTheirWayProps {
  requestCalloutId: string,
  setETA: any
};



const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#001234',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    paddingTop: 10
  },
  label: {
    fontSize: 26,
    fontWeight: 500,
    fontFamily: 'lato',
    color: 'white'
  }
}));


const updateETA = (model: APIResponseModel, setETA: any) => {
  if (model.tomTomRouteETA.durationValue) {
    setETA(preapreETA(model.tomTomRouteETA.durationValue));
    return;
  } else if ((model.tomTomRouteETA.routes?.length ?? 0 > 0)
    &&
    ((model.tomTomRouteETA.routes as APIResponseModelTomTom[])[0].summary.travelTimeInSeconds)) {
    const seconds = (model.tomTomRouteETA.routes as APIResponseModelTomTom[])[0].summary.travelTimeInSeconds;
    setETA(preapreETA(seconds));
    return;
  }
}

const TeamOnTheirWay: React.FC<TeamOnTheirWayProps> = ({ requestCalloutId, setETA }) => {
  const classes = useStyles();
  const [nearestVehicles, setNearestVehicles] = useState<IVehicleLocation[]>([]);
  const [center, setCenter] = useState({ lat: -33.85679100870898, lng: 151.21529457809382 });
  const [zoom, setZoom] = useState(12);
  const timer = React.useRef<any>(null);

  const consumeAPI = async () => {
    try {
      const res = await api.trackCalloutRequestVehicle('', {
        requestCalloutId
        // "timeZone" : "Australia_NSW"
      });
      if (!res.errorRaised) {
        const model:APIResponseModel = res.model;
        if(!model.webFleetVehicleResponse.results || model.webFleetVehicleResponse.results.length === 0){
          console.log("Empty results from webfleet");
          return;
        }
        const vehicleLocation: IVehicleLocation = model.webFleetVehicleResponse.results[0];
        if(!vehicleLocation.latitude || !vehicleLocation.longitude){
          console.log("Empty latitude or longitude from web fleet");
          return;
        }
        updateETA(res.model, setETA);
        setNearestVehicles([vehicleLocation]);
        const { latitude, longitude } = vehicleLocation;
        setCenter({ lat: latitude / 1000000, lng: longitude / 1000000 });
      } else {
        throw res.errorMessage
      }
    } catch (error) {
      console.error(error);
    }
  }

  React.useEffect(() => {
    consumeAPI();
    timer.current = setInterval(async () => await consumeAPI(), 20000);
    return () => {
      clearInterval(timer.current);
    };
  }, [])


  return (
    <div className={classes.root}>
      <GoogleMapReact
        options={{ draggable: true }}
        bootstrapURLKeys={{ key: consts.GooglePlaceAPIKey }}
        defaultCenter={center}
        center={center}
        defaultZoom={zoom}
        zoom={zoom}
      >
        {nearestVehicles.map(({ latitude, longitude, objectNo }: any) => {
          return <TeamVehicleMarker
            key={objectNo}
            lat={latitude / 1000000}
            lng={longitude / 1000000}
          />
        })}
      </GoogleMapReact>
    </div>
  );
}

export default TeamOnTheirWay;